import { ViewRoute } from "./types";
import { RouteNames } from "@dcc/router/definitions";
import { DrinkFrequency } from "@dcc/types/drinkFrequency";

const routeMap = {
  [DrinkFrequency.Never]: RouteNames.profile,
  [DrinkFrequency.Weekly]: RouteNames.drinkerResultsWeekly,
  [DrinkFrequency.TwiceMonthly]: RouteNames.drinkerResultsMonthly,
  [DrinkFrequency.Monthly]: RouteNames.drinkerResultsMonthly
};

export const SingleOccasionRoute: ViewRoute = {
  [RouteNames.singleOccasion]: (factors) => {
    return routeMap[factors.drinkingFrequency];
  }
};
